export enum AuthLoginRequestActionType {
  loading = "AUTH_LOGIN_REQUESTING",
  successful = "AUTH_LOGIN_REQUESTED",
  failed = "AUTH_LOGIN_REQUEST_FAILED",
  reset = "AUTH_LOGIN_REQUEST_RESET",
}
